<template>
  <div v-if="(groupId && busId && bus) || (relatedProp && relatedProp.length)" class="relatedProp">
    <!-- 相关道具栏目，文章和视频页公用 -->
    <div
      v-if="relatedProp && relatedProp.length"
      :class="['commend', packCommend ? 'commend--coll' : '', moreBottom ? 'more-bottom' : '', isVideo ? 'commend--video' : '']"
    >
      <i v-show="packCommend" class="arrow-left" @click="packCommendAction(false)"></i>
      <div v-show="!packCommend" class="commend-content">
        <p class="commend-title">相关商品<i class="icon-close" @click="packCommendAction(true)"></i></p>
        <div class="swiper-container swiper-container--style" :class="isVideo ? 'swiper-container--size' : ''">
          <div class="swiper-wrapper">
            <swiper ref="newsSwiper" :options="swiperOption" class="swiper-wrapper">
              <swiper-slide
                v-for="(prop, index) in relatedProp"
                :key="index"
                :class="['swiper-slide', 'swiper-slide-active', relatedProp.length == 1 ? 'swiper-slide--style' : '']"
                style="margin-right: 16px"
                @click.native="goToPropPage(prop)"
              >
                <img class="commend-img" :src="prop.icon" :alt="prop.name" />
                <div class="commend-info">
                  <span class="commend-info-name">{{ prop.name }}</span>
                  <p class="commend-info-cost">
                    <span class="commend-info-cost--now">{{ prop.salePrice }}{{ bus && bus.unit }}</span>
                    <i class="arrow"></i>
                  </p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <p v-if="bus && !isVideo" class="commend-go" @click="goPropsArea">
          <span>去{{ bus.name }}专区逛逛</span> <i></i>
        </p>
      </div>
    </div>
    <!-- 若没有道具,则只显示去专区入口 -->
    <div
      v-else-if="groupId && busId && bus && !isVideo"
      :class="['commend', 'commend--style', packCommend ? 'commend--coll' : '', moreBottom ? 'more-bottom' : '']"
    >
      <i v-show="packCommend" class="arrow-left" @click="packCommendAction(false)"></i>
      <div v-show="!packCommend" class="commend-content">
        <p class="commend-title">相关商品<i class="icon-close" @click="packCommendAction(true)"></i></p>
        <div class="go-box">
          <div class="swiper-slide">
            <img class="commend-img" :src="bus.icon" :alt="bus.name" />
            <div class="commend-info">
              <span class="commend-info-name">{{ bus.name }}{{ bus.newServiceZone ? "专区" : "" }}</span>
              <span v-if="bus.description" class="commend-info-txt">{{ bus.description }}</span>
            </div>
          </div>
          <div class="go-btn" @click="goPropsArea">去逛逛</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import gameServiceZoneMixin from "../../mixins/gameServiceZone"
import { checkPropCanBuy } from "../../../api/gameProps"
import * as reportDict from "../../../constants/report-dictonary"
import { CONTENT_TYPES } from "../../../store/enums"
import propMixin from "./propMixin"

export default {
  components: {
    swiper,
    swiperSlide
  },
  mixins: [gameServiceZoneMixin, propMixin],
  props: ["content", "moreBottom"],
  data() {
    return {
      groupId: "",
      busId: "",
      goodsIdList: [],
      relatedProp: [],
      packCommend: false,
      swiperOption: {
        slidesOffsetBefore: 0,
        spaceBetween: 16,
        slidesPerView: "auto",
        freeMode: true
      }
    }
  },
  computed: {
    ...mapGetters(["getVmallGoodsList", "getVmallConfigByAMSID"]),
    isVideo() {
      if (this.content) {
        let type = this.content.contentType * 1

        return type === CONTENT_TYPES.shortVideo || type === CONTENT_TYPES.longVideo
      }

      return false
    },
    relatedPropData() {
      let goodsList = []

      if (this.content && this.content.recomInfo && this.content.recomInfo.goodsList) {
        goodsList = this.content.recomInfo.goodsList.split(",")
      }
      return {
        group_busId: (this.content && this.content.recomInfo && this.content.recomInfo.group_busId) || "",
        goodsId: goodsList
      }
    }
  },
  watch: {
    relatedPropData: {
      handler() {
        // 当 relatePropData 变化时 要初始化相关内容
        this.packCommend = false
        this.relatedProp = []
        if (this.relatedPropData && this.relatedPropData.group_busId && this.relatedPropData.group_busId.indexOf("_") > -1) {
          let [groupId, busId] = this.relatedPropData.group_busId.split("_")
          this.groupId = groupId
          this.busId = busId
          this.goodsIdList = this.relatedPropData.goodsId || []
          this.init()
        } else {
          this.relatedProp = []
          this.groupId = ""
          this.busId = ""
          this.goodsIdList = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(["getVmallConfig"]),
    init() {
      if (this.bus) {
        this.getVmallConfig(this.bus).then(() => {
          if (this.goodsIdList && this.goodsIdList.length) {
            this.getPropsByGoodsId(this.goodsIdList, this.relatedPropData.group_busId)
          }
        })

        let pfStructure = this.$route.query.pfStructure

        this.reportUserAction({
          iformat: reportDict.PAGE_VIEW.MALL_CONTENT_RELATED,
          pfStructure,
          resultInfo: {
            contentId: (this.content && this.content.contentId) || "",
            pfStructure
          }
        })
      }
    },
    getPropsByGoodsId(goodsIdList, key) {
      let vmallGoodsList = this.getVmallConfigByAMSID(key)

      if (vmallGoodsList) {
        goodsIdList = goodsIdList.map(item => item.trim())

        for (let i = 0; i < goodsIdList.length; i++) {
          let prop = vmallGoodsList[goodsIdList[i]]

          if (prop && prop.goodsExtend && prop.goodsExtend.ActivityType !== "preOrder" && checkPropCanBuy(prop)) {
            this.relatedProp.push(prop)
          }
        }
      }
    },
    packCommendAction(bool) {
      this.packCommend = bool
      if (!this.packCommend) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.newsSwiper && this.$refs.newsSwiper.swiper && this.$refs.newsSwiper.swiper.update()
          }, 400)
        })
      }
    },
    goToPropPage(prop) {
      let pfStructure = this.$route.query.pfStructure
      this.goToPropDetail({
        prop,
        extendObj: {
          bizgroupid: this.groupId,
          bizid: this.busId
        },
        pfStructure,
        reportIformat: reportDict.CLICK.MALL_CONTENT_RELATED_GOODS,
        resultInfo: {
          contentId: (this.content && this.content.contentId) || "",
          pfStructure
        }
      })
    }
  }
}
</script>

<style scoped>
.commend {
  z-index: 12;
}
.more-bottom {
  bottom: 0.46rem;
}
</style>
